import React, { useState, Fragment }from 'react';
import useForm from 'react-hook-form'
import logo from '../assets/images/endless-logo.png';
import notie from 'notie';
import '../assets/css/notie.css';

import { withRouter } from "react-router";

const Signin = ({ history }) => {
    const [step,setStep] = useState(0);
    const [user,setUser] = useState('');
    const { handleSubmit, register, errors } = useForm();
    const rawReturnTo = new URLSearchParams(window.location.search).get('returnTo') || '';
    const safeReturnTo = rawReturnTo.startsWith('/') ? rawReturnTo : '';

    const loginAuth = async (data) => {
        
        let response = await fetch('/p_login', {
            method: 'POST',
            body: JSON.stringify({user:data.email,pass:data.password}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json()
          /*   console.log('log',res); */
            if(res.estado==1){
                setStep(1);
            }
            else{
                notie.alert({type:'error',text:`Usuario o contraseña incorrectos, favor de verificar sus datos.`,time:2});
            }
        }
        catch{
            notie.alert({type:'error',text:`Ocurrió un error en el servidor, favor de comunicarse con soporte técnico.`,time:2});
        }
    }

    const codeAuth = async (data) => {
        
        let response = await fetch('/p_code', {
            method: 'POST',
            body: JSON.stringify({code:data.codigo,user:user}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json()
            console.log('log',res);
            if(res.estado==1){
                notie.alert({type:'success',text:`Bienvenido (a) ${res.resultado.nombre} ${res.resultado.apellidos}`,time:2});
                const target = safeReturnTo || '/inicio';
                setTimeout(()=> window.location.replace(target),1300);
            }
            else{
                const errorMessage = res.resultado || 'Codigo incorrecto, favor de verificar sus datos.';
                notie.alert({type:'error',text:errorMessage,time:2});
            }
        }
        catch{
            notie.alert({type:'error',text:`Ocurrió un error en el servidor, favor de comunicarse con soporte técnico.`,time:2});
        }
    }

    const onSubmit = data => {
        if(!step){
            if (data !== '') {
                loginAuth(data);
            } else {
              errors.showMessages();
            }
        }
        else{
            if (data !== '') {
                codeAuth(data);
            } else {
              errors.showMessages();
            }
        }
      };


    return (
        <div>
            <div className="page-wrapper">
                <div className="container-fluid p-0">
                    {/* <!-- login page start--> */}
                    <div className="authentication-main">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="auth-innerright">
                                    <div className="authentication-box">
                                        <div className="text-center">
                                            <img src={logo} width="200" alt="" /></div>
                                        <div className="card mt-4">
                                            <div className="card-body">
                                                {!step?
                                                <Fragment>
                                                    <div className="text-center">
                                                        <h6>Inicio de Sesión</h6>
                                                    </div>
                                                    <form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
                                                        <div className="form-group">
                                                            <label className="col-form-label pt-0">Usuario</label>
                                                            <input className="form-control" type="text" name="email"
                                                                ref={register({required: "Required"})}
                                                                placeholder="email@dominio.com"
                                                                value={user}
                                                                onChange={(e)=>setUser(e.target.value)}
                                                            />
                                                            <p className="text-danger">{errors.email && 'Ingrese su usuario'}</p>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="col-form-label">Contraseña</label>
                                                            <input className="form-control" type="password" name="password"
                                                                placeholder="*******"
                                                                ref={register({required: "Required"})} />
                                                                <p className="text-danger">{errors.password && 'Ingrese su contraseña'}</p>
                                                        </div>
                                                        <div className="form-group form-row mt-3 mb-0">
                                                            <button className="btn btn-primary btn-block" type="submit" >INICIAR SESIÓN</button>
                                                        </div>
                                                    </form>
                                                </Fragment>
                                                :
                                                <Fragment>
                                                    <div className="text-center">
                                                        <h6>Ingrese el código </h6>
                                                        <p className="text-muted" >Ingresa el código que enviamos a tu correo para continuar.</p>
                                                    </div>
                                                    <form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
                                                        <div className="form-group">
                                                            <input className="form-control text-center" type="text" name="codigo"
                                                                ref={register({required: "Required"})}
                                                            />
                                                            <p className="text-danger">{errors.codigo && 'Ingrese el codigo correcto'}</p>
                                                        </div>
                                        
                                                        <div className="form-group form-row mt-3 mb-0">
                                                            <button className="btn btn-primary btn-block" type="submit" >CONTINUAR</button>
                                                        </div>
                                                    </form>
                                                </Fragment>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- login page end--> */}
                </div>
            </div>
        </div>
    );
};

export default withRouter(Signin);
